import moment from "moment";

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const getBlockProps = ({
  data,
  property,
  formatFunction,
  addMonths = 0,
  invertTags,
}) => {
  if (data?.data?.values && property) {
    const graphLength = data.data.values.length;
    const currentMonthValues = data.data.values[graphLength - 1];
    const currentMonthValue = currentMonthValues?.[property];
    const previousMonthValues = data.data.values[graphLength - 2];
    const lastMonthValue = data.data.values[graphLength - 2]?.[property];
    const lastMonth =
      previousMonthValues &&
      capitalize(
        moment(previousMonthValues.x).add(addMonths, "M").format("MMMM")
      );

    const growthDirection = () => {
      if (lastMonthValue === undefined) {
        return null;
      }
      if (invertTags) {
        if (currentMonthValue < lastMonthValue) {
          return "up";
        }
        if (currentMonthValue > lastMonthValue) {
          return "down";
        }
      }
      if (currentMonthValue > lastMonthValue) {
        return "up";
      }
      if (currentMonthValue < lastMonthValue) {
        return "down";
      }
      return null;
    };

    if (invertTags) {
      return {
        highlight:
          previousMonthValues &&
          !Number.isNaN(previousMonthValues[property]) &&
          (formatFunction
            ? formatFunction(previousMonthValues[property])
            : previousMonthValues[property]),
        growthDirection: growthDirection(),
        caption:
          currentMonthValues &&
          !Number.isNaN(currentMonthValues[property]) &&
          `${lastMonth}: ${
            formatFunction
              ? formatFunction(currentMonthValues[property])
              : currentMonthValues?.[property]
          }`,
      };
    }

    return {
      highlight:
        !Number.isNaN(currentMonthValues[property]) &&
        (formatFunction
          ? formatFunction(currentMonthValues[property])
          : currentMonthValues[property]),
      caption:
        !Number.isNaN(previousMonthValues[property]) &&
        `${lastMonth}: ${
          formatFunction
            ? formatFunction(previousMonthValues[property])
            : previousMonthValues?.[property]
        }`,
      growthDirection: growthDirection(),
    };
  }
  return {
    highlight: "",
    caption: "",
    growthDirection: undefined,
  };
};
